import { render, staticRenderFns } from "./SearchRelated.vue?vue&type=template&id=8b105b88&"
import script from "./SearchRelated.vue?vue&type=script&lang=js&"
export * from "./SearchRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports